export const prepareScheduling = (data) => {
  const schedulingsData = JSON.parse(JSON.stringify(data));
  schedulingsData.forEach((e, index) => {
    e.key = index;
    e.number = index + 1;
  });
  return schedulingsData;
};
